module.exports = {"TXTWCL_EW":{"id":"TXTWCL_EW","defaultMessage":"EW"}}